/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const hide = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.67 4.03A5.544 5.544 0 0 0 8 4c-2.51-.042-5.103 1.711-6.734 3.506a1.035 1.035 0 0 0 0 1.385c.226.25.471.499.734.743m12-2.87c.261.244.507.493.734.742a1.035 1.035 0 0 1 0 1.385C13.137 10.65 10.55 12.441 8 12.4a5.552 5.552 0 0 1-.61-.024M14.221 2 1.777 14.445"
    />
  </svg>
)
export default hide
